import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import Shell from './shell/Shell';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from "./authentication/authConfig";
import { PublicClientApplication } from '@azure/msal-browser';
import 'semantic-ui-less/semantic.less'

const container = document.getElementById('root')!;
const root = createRoot(container);
const msalInstance = new PublicClientApplication(msalConfig);

root.render(
  <React.StrictMode>
		<Router>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <Shell />
        </Provider>
      </MsalProvider>
		</Router>
</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
